/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {SERVER_URL} from './server-url';
import {ApiUtilsService} from './api-utils.service'
import {
    BottleDto,
    PageWineBoxFullSummaryDto,
    PageWineBoxRecordDto,
    TagStatusDto,
    WineBoxCreateUpdateRequestDto,
    WineBoxFullSummaryDto,
    WineBoxSummaryDto
} from '../domain';


@Injectable({
    providedIn: 'root'
})
export class WineBoxControllerService {

    constructor(
        @Inject(SERVER_URL) private _serverUrl: string,
        private _httpClient: HttpClient,
        private _apiUtils: ApiUtilsService
    ) {
    }

    private _headers: HttpHeaders = undefined;

    addCustomHeader(headerName: string, headerValue: string | string[]): this {
        if (!this._headers) {
            this._headers = new HttpHeaders();
        }
        this._headers = this._headers.append(headerName, headerValue);
        return this;
    }


        addBottleToBox(
                    boxId: number,
                    bottleTid: string
                , 
                queryParams: {
                    userLegalEntityId: number
                }
    ): Observable<BottleDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/box/add/${boxId}/bottle/${bottleTid}`;

            return this._httpClient.put<BottleDto>(url, requestBody, requestOptions);
    }


        checkIsBoxAvailable(
                    tid: string
    ): Observable<TagStatusDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/box/${tid}/pallet/available`;

            return this._httpClient.get<TagStatusDto>(url, requestOptions);
    }


        checkTagStatus(
                    tid: string
    ): Observable<TagStatusDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/box/${tid}/status`;

            return this._httpClient.get<TagStatusDto>(url, requestOptions);
    }


        completeBox(
                    boxId: number,
                    tid: string
                , 
                queryParams: {
                    userLegalEntityId: number
                }
    ): Observable<any> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/box/${boxId}/complete/${tid}`;

            return this._httpClient.put(url, requestBody, requestOptions);
    }


        createNewWineBox(
                
                queryParams: {
                    userLegalEntityId: number
                }
                    
                    , 
                    requestBody: WineBoxCreateUpdateRequestDto
    ): Observable<number> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/box/`;

            return this._httpClient.post<number>(url, requestBody, requestOptions);
    }


        getBoxingHistory(
                    orgUnitId: number
                , 
                queryParams: {
                    page?: number,
                    size?: number,
                    sort?: Array<string>
                }
    ): Observable<PageWineBoxRecordDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/box/history/${orgUnitId}`;

            return this._httpClient.get<PageWineBoxRecordDto>(url, requestOptions);
    }


        getWineBoxById(
                    id: number
    ): Observable<WineBoxFullSummaryDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/box/${id}`;

            return this._httpClient.get<WineBoxFullSummaryDto>(url, requestOptions);
    }


        getWineBoxByTid(
                    tid: string
    ): Observable<WineBoxSummaryDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/box/tid/${tid}`;

            return this._httpClient.get<WineBoxSummaryDto>(url, requestOptions);
    }


        loadPageByConsumer(
                    userId: number
                , 
                queryParams: {
                    type?: string,
                    bottlesNumber?: number,
                    bottleSizeId?: string,
                    userLegalEntityId?: number,
                    page?: number,
                    size?: number,
                    sort?: Array<string>
                }
    ): Observable<PageWineBoxFullSummaryDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/box/page/${userId}/user`;

            return this._httpClient.get<PageWineBoxFullSummaryDto>(url, requestOptions);
    }


        loadPageByProducer(
                    orgUnitId: number
                , 
                queryParams: {
                    type?: string,
                    bottlesNumber?: number,
                    bottleSizeId?: string,
                    userLegalEntityId: number,
                    page?: number,
                    size?: number,
                    sort?: Array<string>
                }
    ): Observable<PageWineBoxFullSummaryDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/box/page/${orgUnitId}`;

            return this._httpClient.get<PageWineBoxFullSummaryDto>(url, requestOptions);
    }


        modifyWineBox(
                    id: number
                , 
                queryParams: {
                    userLegalEntityId: number
                }
                    , 
                    
                    requestBody: WineBoxCreateUpdateRequestDto
    ): Observable<WineBoxFullSummaryDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/box/${id}`;

            return this._httpClient.put<WineBoxFullSummaryDto>(url, requestBody, requestOptions);
    }


        removeBottleFromBox(
                    boxId: number,
                    bottleTid: string
                , 
                queryParams: {
                    userLegalEntityId: number
                }
    ): Observable<any> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/box/remove/${boxId}/bottle/${bottleTid}`;

            return this._httpClient.put(url, requestBody, requestOptions);
    }


        unpackWineBox(
                    id: number
                , 
                queryParams: {
                    ownerType: string,
                    ownerId: number,
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/box/unpack/${id}`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


}

